
import { Component, OnInit, NgZone, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { IAppConfig } from 'src/config/app-config.model';
import { AppConfig } from 'src/config/app-config.service';
import { BaseTranslation } from 'src/core/translation/model/translation.base';
import { TranslateService } from '@ngx-translate/core';
import { Language } from 'src/core/utility/enums/enums';
import { UpdateUsernameService } from 'src/shared/services/updateUsername.service';
import { WelcomeService } from '../welcome.service';
import { UserType } from 'src/projects/login/src/app/Enums/UserType';
import { Helper } from 'src/core/utility/helper/helper';
import { User } from 'src/projects/registration/src/app/models/user';

@Component({
  selector: 'adahi-welcome',
  templateUrl: './welcome.component.html'
})
export class WelcomeComponent extends BaseTranslation implements OnInit, AfterViewInit {
  @ViewChild('userInfoName') userInfoName: ElementRef;
  appSettings: IAppConfig;
  isRepresentative: boolean = false;
  isIndividual: boolean = false;
  isCharityManager: boolean = false;

  activeRepresentative: boolean = false;
  editProfileUrl: string = '';
  representativeProfileUrl: string = '';
  batchListUrl: string = '';
  changePasswordUrl: string = '';
  charityManagerProfileUrl:string='';
  charitySubmitNewCartoonRequestUrl:string='';
  userName: string = '';
  logoutUrl: string = '';
  orderHistoryUrl: string = '';
  affiliateDetailsLink:string='';
  currentLanguage: string;
  isAdmin: boolean = false;
  currentUser: User;
  userTypeEnum = UserType;
  shippedCharityShipmentsRequestUrl: string='';
  isAffiliate: boolean=false;

  constructor(translateService: TranslateService, ngZone: NgZone, private updateUsernameService: UpdateUsernameService, private welcomeService: WelcomeService) {
    super(translateService, ngZone);
    this.appSettings = AppConfig.settings;
    this.currentLanguage = Language[_spPageContextInfo.currentLanguage];
    this.editProfileUrl = _spPageContextInfo.siteAbsoluteUrl + "/" + this.currentLanguage + this.appSettings.editProfileUrl;
    this.representativeProfileUrl = _spPageContextInfo.siteAbsoluteUrl + '/' + this.currentLanguage + this.appSettings.representativePageUrl;
    this.affiliateDetailsLink = _spPageContextInfo.siteAbsoluteUrl + '/' + this.currentLanguage + this.appSettings.affiliateProfilePageUrl;
    this.charityManagerProfileUrl = _spPageContextInfo.siteAbsoluteUrl + '/' + this.currentLanguage + this.appSettings.charityManagerProfileUrl;
    this.charitySubmitNewCartoonRequestUrl = _spPageContextInfo.siteAbsoluteUrl + '/' + this.currentLanguage + this.appSettings.submitNewCartoonRequestUrl;
    this.shippedCharityShipmentsRequestUrl = _spPageContextInfo.siteAbsoluteUrl + '/' + this.currentLanguage + this.appSettings.shippedCharityShipments;
    this.batchListUrl = _spPageContextInfo.siteAbsoluteUrl + '/' + this.currentLanguage + this.appSettings.batchListPageUrl;
    this.changePasswordUrl = _spPageContextInfo.siteAbsoluteUrl + "/" + this.currentLanguage + this.appSettings.changePasswordUrl;
    this.orderHistoryUrl = _spPageContextInfo.siteAbsoluteUrl + "/" + this.currentLanguage + this.appSettings.orderHistoryUrl;
    this.logoutUrl = _spPageContextInfo.siteAbsoluteUrl + this.appSettings.logoutUrl;

  }

  isLtr(string) {
    return string.match(/[a-z]+|^[\#\w]+$/gi) !== null;
  }

  handleClick() {
    document.querySelectorAll('.ms-core-navigation .arrow').forEach(function (arrow) {
      (<HTMLElement>arrow).classList.remove('arrow-down');
      arrow.nextElementSibling.classList.remove('is-active');
      arrow.parentElement.classList.remove('is-active');
    });
  }

  ngOnInit() {

    if (!Helper.userInfo().isAdmin) {

      this.loadUserDetails();

      this.subscribeToProfileUpdateService();

    } else {
      this.isAdmin = true;
    }
  }

  subscribeToProfileUpdateService() {
    this.updateUsernameService.profileUpdatedConfirmed$.subscribe(
      username => {
        this.userName = username;
      });
  }

  loadUserDetails() {
    this.welcomeService.getCurrentUser().subscribe(user => {
      
      this.currentUser = user;
      
      this.assignUserType(user);
      
      if (this.isRepresentative) {
        localStorage.setItem('rep', '1');
      } else {
        localStorage.setItem('rep', '0');
      }

      this.userName = user.firstName + " " + user.lastName;
      if (this.isLtr(this.userName)) {
        this.userInfoName.nativeElement.setAttribute('dir', 'ltr');
      } else {
        this.userInfoName.nativeElement.setAttribute('dir', 'rtl');
      }
    });
  }

  assignUserType(user: any) {
    this.isRepresentative = user.userType == UserType.Representative;
    this.isIndividual = user.userType == UserType.Individual;
    this.isCharityManager = user.userType == UserType.CharityManager;
    this.isAffiliate =  user.userType == UserType.Affiliate;
    this.activeRepresentative = (user.userType == UserType.Representative && user.active);
  }

  ngAfterViewInit() {
  }

  logout($event) {
    $event.preventDefault();
    if (localStorage.getItem('rep') != null)
      localStorage.removeItem('rep');
    window.location.href = this.logoutUrl;
  }
}